// Shared localStorage keys
export const ELocalStorageKey = {
  Token: 'x-auth-token',
  Username: 'username',
  UserId: 'user_id',
  WorkspaceId: 'workspace_id',
  WorkspaceName: 'workspace_name',
  WorkspaceDesc: 'workspace_desc',
  PlatformName: 'platform_name',
  GatewayOnline: 'gatewayOnline',
  Device: 'device',
  Flag: 'flag',
  WebsdkNgInstallId: 'websdk_ng_install_id',
  MqttConfig: 'mqttConfig', // Standardized key for MQTT configuration
  WsUrl: 'wsUrl', // Standardized key for WebSocket URL
  ControllerSN: 'controller_sn' // Controller serial number for device binding
};

// API endpoints
export const API_ENDPOINTS = {
  LOGIN: '/api/auth/pilot-login',
  USER_INFO: '/api/user/info',
  PLATFORM_INFO: '/api/workspace/info',
  DEVICE_INFO: (workspaceId, deviceSn) => `/api/workspace/${workspaceId}/devices/${deviceSn}`,
  BIND_DEVICE: (deviceSn) => `/api/devices/${deviceSn}/binding`
}; 